"use client";

import { useTranslations } from "use-intl";

import { ArrowForwardIcon, ReleaseIcon } from "@/components/appIcons";
import { Link } from "@/components/link";
import type { DealOffer } from "@/components/marketplace/deal-offers-types";

/**
 * Release scope, when the best offer belongs to a sibling edition: an amber context line naming
 * that edition plus a secondary link to its release page.
 */
export function BestDealOfferOtherEditionNotice({ offer }: { offer: DealOffer }) {
  const t = useTranslations("shared.affiliates");

  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1 rounded-lg bg-amber-300/10 px-3 py-2 text-[13px] text-amber-300">
      <p className="flex min-w-0 flex-1 basis-48 items-center gap-1.5">
        <ReleaseIcon aria-hidden="true" className="shrink-0 text-sm" />
        <strong className="shrink-0 font-bold">{t("otherEdition")}</strong>
        <span className="min-w-0 truncate text-amber-100/80" title={offer.title}>
          · {offer.title}
        </span>
      </p>
      {offer.matchCatalogId && (
        <Link
          to="/release/$id"
          params={{ id: offer.matchCatalogId }}
          className="-mx-1 inline-flex min-h-11 shrink-0 items-center gap-1 rounded-md px-1 font-bold text-amber-300 underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300 lg:min-h-7"
        >
          {t("viewThisEdition")}
          <ArrowForwardIcon aria-hidden="true" className="text-sm" />
        </Link>
      )}
    </div>
  );
}
